
export const imageTooltipTitleStyle = {
    maxWidth: "800px", // Increase tooltip container size
    maxHeight: "800px",
    background: "#fff",
    padding: "10px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

export const imageTooltipTitleImageStyle = {
    width: "100%", // Make it fill the container
    height: "auto", // Keep aspect ratio
    maxWidth: "800px", // Allow the image to be larger
    maxHeight: "800px",
    objectFit: "contain",
};

export const imageTooltipPopperStyle = {
    modifiers: [
        {
            name: "preventOverflow",
            options: {
                boundary: "window",
            },
        },
    ],
    sx: {
        "& .MuiTooltip-tooltip": {
            maxWidth: "none", // Remove default tooltip width restriction
        },
    },
};

export const mediaModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
    width: {
        xs: "90vw", // mobile
        sm: "80vw", // small tablets
        md: "60vw", // desktop
        lg: "50vw", // large screens
    },
    maxHeight: "90vh",
    overflow: "auto",
};
